import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";

import styles from "./KioskInstructionSection.module.scss";

import img_icon_info_icon from "@/Globals/_images/icons/info_icon.png";

interface IKioskInstructionSectionProps {
    localizedKioskInstruction: LocalizedTextDto;
}

function KioskInstructionSection(props: Readonly<IKioskInstructionSectionProps>): JSX.Element {
    const { localizedKioskInstruction } = props;

    return (
        <>
            <div className={`${styles.kioskSectionHeader} view-section-header`}>
                <h3 className="view-section-title">{cacheStore.GetString("ClinicInfo_KioskInstructionLabel")}</h3>
                <img
                    alt="Info-Icon"
                    className={styles.kioskSectionHeaderIcon}
                    src={img_icon_info_icon}
                    title={cacheStore.GetString("ClinicInfo_KioskInstructionIconInfo")}
                />
            </div>

            <div className="view-section-body">
                {AdministrationHelper.getLocalizedTextSiteViewArray(localizedKioskInstruction).map(item => (
                    <div key={`siteKiosk_${item.languageName}`} className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{item.languageName}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer note-container">
                            <strong>{item.value}</strong>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { IKioskInstructionSectionProps };
export default KioskInstructionSection;
